export default {"src":"/_next/static/media/mb_venture.140461b7.svg","height":124,"width":100,"blurWidth":0,"blurHeight":0};